// shared/domain/formatoImagen.js  (formato REAL de una imagen por su contenido; puro, sin DOM)

export const BYTES_CABECERA = 12;
export const FORMATOS_PERMITIDOS = ['jpeg', 'png'];

const PNG = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
const BRANDS_HEIC = ['heic', 'heix', 'hevc', 'mif1', 'msf1', 'heif'];

const ascii = (bytes, desde, hasta) => String.fromCharCode(...Array.from(bytes).slice(desde, hasta));
const empieza = (bytes, firma) => firma.every((b, i) => bytes[i] === b);

/** Detecta el formato por magic bytes. bytes: Uint8Array | number[] (basta con los primeros 12). */
export const detectarFormatoImagen = bytes => {
  if (!bytes || bytes.length < 3) return 'otro';
  if (empieza(bytes, [0xff, 0xd8, 0xff])) return 'jpeg';
  if (bytes.length >= PNG.length && empieza(bytes, PNG)) return 'png';
  if (bytes.length >= 12 && ascii(bytes, 0, 4) === 'RIFF' && ascii(bytes, 8, 12) === 'WEBP') return 'webp';
  if (bytes.length >= 6 && ['GIF87a', 'GIF89a'].includes(ascii(bytes, 0, 6))) return 'gif';
  if (bytes.length >= 12 && ascii(bytes, 4, 8) === 'ftyp' && BRANDS_HEIC.includes(ascii(bytes, 8, 12))) return 'heic';
  return 'otro';
};

export const esFormatoPermitido = formato => FORMATOS_PERMITIDOS.includes(formato);
